import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import {
  EMPTY_OBJECT,
  FLOATING_ELEMENT_PLACEMENT,
} from '../../../constants/common'
import {
  QA_NAME_PROFILE_INFO_ITEM,
  QA_NAME_PROFILE_INFO_ITEM_TITLE,
} from '../../../constants/qa'
import { useContentOverflow } from '../../../hooks'
import { getQaSelector } from '../../../utils/common'
import { FloatingTooltip } from '../../Floating'
import { ICON_HEIGHT_16, IconWithTooltip } from '../../Icon'
import Text from '../../Text'
import { EntityProfileHeaderInfoItemActions } from '../EntityProfileHeaderInfoItemActions'
import { EntityProfileHeaderInfoItemLoading } from '../EntityProfileHeaderInfoItemLoading'

import * as styles from './EntityProfileHeaderInfoItemBase.module.css'

import InfoIcon from '../../../icons/info.svg'

function EntityProfileHeaderInfoItemBase({
  ItemActions = EntityProfileHeaderInfoItemActions,
  actions,
  canEdit = true,
  children,
  className = styles.EntityProfileHeaderInfoItemBase,
  contentExist,
  contentWrapperClassName,
  contentWrapperProps,
  handlers,
  isLoading,
  itemActionsProps = EMPTY_OBJECT,
  ref,
  title,
  titleClassName,
  titleInfoKey,
  tooltip,
  value,
}) {
  const { t } = useTranslation()

  const { overflow, setContentOverflowRef } = useContentOverflow({
    externalRef: ref,
  })

  return (
    <div
      {...getQaSelector({ value: QA_NAME_PROFILE_INFO_ITEM })}
      className={className}
    >
      {isLoading ? (
        <EntityProfileHeaderInfoItemLoading />
      ) : (
        <>
          <div className={styles.titleWrapper}>
            <Text
              isSecondary
              className={titleClassName}
              qaName={QA_NAME_PROFILE_INFO_ITEM_TITLE}
            >
              {t(title)}
            </Text>
            {titleInfoKey ? (
              <IconWithTooltip
                Icon={InfoIcon}
                size={ICON_HEIGHT_16}
                tooltip={t(titleInfoKey)}
                tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
              />
            ) : null}
          </div>
          <div
            {...contentWrapperProps}
            className={classNames(
              styles.contentWrapper,
              {
                [styles.contentWrapperWithButton]: canEdit,
              },
              contentWrapperClassName
            )}
          >
            <FloatingTooltip
              content={tooltip}
              disabled={!overflow}
              placement={FLOATING_ELEMENT_PLACEMENT.top}
            >
              <div className={styles.content} ref={setContentOverflowRef}>
                {children}
              </div>
            </FloatingTooltip>
            <ItemActions
              {...itemActionsProps}
              actions={actions}
              className={styles.editButton}
              contentExist={contentExist}
              handlers={handlers}
              value={value}
            />
          </div>
        </>
      )}
    </div>
  )
}

export default EntityProfileHeaderInfoItemBase
